module.exports = __webpack_public_path__ + "img/jpg.6b02caa6.png";